import { HeatmapOptions } from 'app/modules/wallforming/components/content-container/scene-status-bar/heatmap-controls/HeatmapOptions';
import { LabelVisibilityToggle } from 'app/modules/wallforming/components/content-container/scene-status-bar/heatmap-controls/LabelVisibilityToggle';
import { MetricVisibilityToggle } from 'app/modules/wallforming/components/content-container/scene-status-bar/heatmap-controls/MetricVisibilityToggle';

export const HeatmapControls = () => {
    return (
        <span className="flex shrink-0 ml-1">
            <HeatmapOptions />
            <LabelVisibilityToggle />
            <MetricVisibilityToggle />
        </span>
    );
};
